import * as React from "react";
import {WPTable} from "shared/controls/WPTable/WPTable";
import {WPBasicColumn} from "shared/controls/WPTable/Columns/WPBasicColumn";

export class WPTR extends React.Component<WordpressRowProps, WordpressRowState> {
    static defaultProps: Partial<WordpressRowProps> = {};

    constructor(props: WordpressRowProps) {
        super(props);
        this.state = {};
    }

    public render() {
        return (
            <tr>
                {this.props.WPTable.Columns.map((column,index)=>
                    <td style={{...column.props.styles,width:column.props.Width,left:(index==0?this.props.WPTable.props.StickyLeft:null)}} key={column.props.PropertyName} data-colname={column.props.Title} className={this.CreateColumnClassNames(column,index)}>
                        {column.props.HasCheckBox&&
                            <input style={{marginRight:5}} type={'checkbox'} checked={this.props.Data[column.props.CheckBoxProperty]} onChange={x=>{this.props.Data[column.props.CheckBoxProperty]=x.target.checked;this.forceUpdate()}}/>

                        }
                            {this.GenerateColumn(this.props.Data,column)}

                        {column.props.Actions.length>0&&
                        <div className={'row-actions'}>
                            {
                                column.props.Actions.map((action,index)=>
                                    <span key={action.Id} className={action.ClassName}>
                                                            <a style={{float:"none"}} href={'#'} className={action.Id} onClick={e=>{e.preventDefault();this.props.WPTable.props.ActionClicked&&this.props.WPTable.props.ActionClicked(action.Id,this.props.Data,e)}}>{action.Title}</a>
                                        {index<column.props.Actions.length-1&&" | "}
                                                        </span>

                                )
                            }
                        </div>

                        }
                    </td>
                )}
            </tr>
        )
    }


    private GenerateColumn(row: any, property: WPBasicColumn) {
        let value='';
        if(row[property.props.PropertyName]!=null)
            value=row[property.props.PropertyName];

        if(property.props.Formatter!=null)
            value=property.props.Formatter(value,property.props,row);

        if(property.props.children!=null)
            return (property.props as any).children(row,this);



        if(property.props.IsClickable)
        {
            return (
                <a href={'#'} className={property.props.IsPrimary?'row-title':''} onClick={e=>{e.preventDefault();this.props.WPTable.props.RowClicked&&this.props.WPTable.props.RowClicked(row,e)}}>
                    {value}
                </a>
            )
        }else
            return value;
    }

    private CreateColumnClassNames(column: WPBasicColumn,index:number) {
        let classes='';
        classes= column.props.IsNumeric?'rnNumeric':''

        if(this.props.WPTable.props.StickyLeft!=null&&index==0)
        {
            classes+=' rnStickyHeader';
        }

        return classes;
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface WordpressRowProps {
 WPTable:WPTable;
 Data:any;
 Index:number;
}

interface WordpressRowState {

}

//#endregion "My Region"